import { useCallback } from 'react';
import { useUtcDateTimeLazyQuery } from '@lingoda/monolith-graphql';
import { type ApiTimeResponse } from '../logic';

export const useApiTime = () => {
    const [fetchUtcTime] = useUtcDateTimeLazyQuery({ fetchPolicy: 'no-cache' });

    // The lazy query never rejects: a failed request resolves with `error` and no `data`
    const fetchApiTime = useCallback(async (): Promise<ApiTimeResponse> => {
        const { data, error } = await fetchUtcTime();

        return { apiTimeUTC: data?.utcDateTime, error };
    }, [fetchUtcTime]);

    return { fetchApiTime };
};
